module.exports = __webpack_public_path__ + "img/inboxaware-mobile-logo.8e4b8981.svg";